import { css } from '@emotion/react'
import { colors, Theme, useTheme, VFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { canRegisterCid10 } from '../plano/cuidado-compartilhado/cuidado-compartilhado-form/utils-cuidadoCompartilhado'
import { AntecedentesFamiliaresCiapField } from './componentes/AntecedentesFamiliaresCiapField'
import { FamiliarAntecedentesModel } from './model-antecedentes'

export interface FamiliarAntecedentesViewProps {
  name: MetaPath<FamiliarAntecedentesModel>
  cidadao?: CidadaoAtendimento
}

export function FamiliarAntecedentesView(props: FamiliarAntecedentesViewProps) {
  const { name, cidadao } = props
  const {
    acesso: {
      cbo: { cbo2002 },
    },
  } = useAcessoLotacaoOrEstagio()
  const theme = useTheme()
  const classes = createStyles(theme)
  const canAddCid10 = canRegisterCid10(cbo2002)

  return (
    <VFlow style={classes.container}>
      <AntecedentesFamiliaresCiapField
        cidadao={cidadao}
        name={name.ciaps}
        canAddCid10={canAddCid10}
        dataTestId='antecedentesFamiliares'
      />
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    margin-top: 0.5rem;
    padding: 1rem;
    border: 1px ${colors.pink.c60} solid;
    border-radius: ${theme.radius.input}px;
  `,
})
